import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { searchToObject } from 'ouisys-engine/utilities/searchToObject';
import { setConfig } from 'ouisys-engine/utilities/getConfig';
import { useSelector } from 'react-redux';
import { usePinFlowState } from 'ouisys-engine/pinFlow';
import configJson from '../../config.json';
import { IStrategy } from 'ouisys-engine/strategy';

setConfig(configJson as IStrategy);
const config = configJson as IStrategy;
const RootContext = createContext(undefined);

// custom hook to easily use the context accross the app
export const useRootContext = () => useContext(RootContext);

export const RootProvider = ({ children }) => {
  const defaultFlow = config?.strategyConfigs?.default?.flow || '';
  const urlParams = searchToObject(window);
  const d_locale = urlParams['locale'];
  const [operator, setOperator] = useState(null);
  const [msisdn, setMsisdn] = useState('+51');
  const [locale, setLocale] = useState('es');
  const [skipPrelander, setSkipPrelander] = useState(urlParams['skip-prelander'] === 'true' || true);
  const [isMoview, setIsMoView] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [internationalNumber, setInternationalNumber] = useState(msisdn);
  const phoneInputRef = useRef(null);
  const [shake, setShake] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  // Peru - user plan type if prepaid or postpaid
  const pinFlowState = usePinFlowState(useSelector);
  const pinFlowData = pinFlowState?.data;
  const userType = pinFlowData?.userType || urlParams['userType'] || '';
  
  const switchLang = (lang: string) => {
    setLocale(lang);
    if (typeof window !== 'undefined') {
      window.languageCode = lang;
      document.getElementsByTagName('html')[0].setAttribute('lang', lang);
    }
  };
  
  const value = {
    config,
    defaultFlow,
    urlParams,
    operator,
    setOperator,
    msisdn,
    setMsisdn,
    locale,
    switchLang,
    skipPrelander,
    setSkipPrelander,
    isMoview,
    setIsMoView,
    isChecked,
    setChecked,
    internationalNumber,
    setInternationalNumber,
    phoneInputRef,
    shake,
    setShake,
    showModal,
    setShowModal,
    userType,
  };

  useEffect(() => {
    if (typeof window != 'undefined') {
      window.languageCode = locale;
      document.getElementsByTagName('html')[0].setAttribute('lang', locale);
    }

    // set locale based on url param
    if (d_locale) {
      setLocale(d_locale);
    }
  }, []);

  return (
    <RootContext.Provider value={value}>
      {children}
    </RootContext.Provider>
  );
};
